
const routes = [
    {
        name: 'layout',
        path: '/',   // 路由到layout组件，layout里需要routerView才能路由到子组件
        component: ()=>import('@/containers/layout/layout.vue'),
        children: [
            {
                name: '富文本内容展示',
                path: '/ovis',
                component: ()=>import('@/containers/ovis/ovis.vue')
            },
            {
                name: '用户协议',
                path: '/userProtocol',
                component: ()=>import('@/containers/ovis/userProtocol.vue')
            },
            {
                name: '隐私政策',
                path: '/privacyPolicy',
                component: ()=>import('@/containers/ovis/privacyPolicy.vue')
            },
            {
                name: 'demo',
                path: '/demo',
                component: () => import('@/containers/demo.vue')
            }
        ]
    }
]

export default routes;


// WEBPACK FOOTER //
// ./src/router/routes.js